import { useQuery } from '@tanstack/react-query';
import { getContactCategories } from '../api/contacts';

export function useContactCategories() {
  return useQuery({
    queryKey: ['contact-categories'],
    queryFn: getContactCategories,
    staleTime: 5 * 60 * 1000,
  });
}
